import { Navigate, Route, Routes } from 'react-router'
import { observer } from 'mobx-react-lite'
import { NumbersPage } from 'pages/settings/pages/numbers/ui/NumbersPage'
import { NumbersProviderLayout } from 'pages/settings/pages/numbers/layout/numbersProviderLayout'
import { AddNumbersRoutes, AddNumberRouter } from 'pages/settings/pages/numbers/pages/AddNumber'
import {
  AddNumberFromAppRoutes,
  AddNumberFromAppStepsRouter,
} from 'pages/settings/pages/numbers/pages/AddNumberFromApp'
import { BuyNumberRoutes, BuyNumberStepsRouter } from 'pages/settings/pages/numbers/pages/BuyNumber'
import {
  TextEnableLandlineRoutes,
  TextEnableLandlineStepsRouter,
} from 'pages/settings/pages/numbers/pages/TextEnableLandline'
import { NumbersAccessLayout } from 'pages/settings/pages/numbers/layout/numbersAccessLayout'
import { NumbersSubscriptionCanceledLayout } from 'pages/settings/pages/numbers/layout/numbersSubscriptionCanceledLayout'
import {
  ImportTwilioNumbersRoutes,
  ImportTwilioNumbersRouter,
} from 'pages/settings/pages/numbers/pages/ImportTwilioNumbers'

export const NumbersRouter = observer(() => {
  return (
    <Routes>
      <Route element={<NumbersAccessLayout />}>
        <Route element={<NumbersProviderLayout />}>
          <Route path={'/'} element={<NumbersPage />} />

          <Route element={<NumbersSubscriptionCanceledLayout />}>
            <Route path={`/${AddNumbersRoutes.root}/*`} element={<AddNumberRouter />} />
            <Route path={`${BuyNumberRoutes.root}/*`} element={<BuyNumberStepsRouter />} />
            <Route
              path={`${TextEnableLandlineRoutes.root}/*`}
              element={<TextEnableLandlineStepsRouter />}
            />
            <Route
              path={`${AddNumberFromAppRoutes.root}/*`}
              element={<AddNumberFromAppStepsRouter />}
            />
            <Route
              path={`/${ImportTwilioNumbersRoutes.root}/*`}
              element={<ImportTwilioNumbersRouter />}
            />
          </Route>

          <Route path={'*'} element={<Navigate to={'/'} replace />} />
        </Route>
      </Route>
    </Routes>
  )
})
